<!-- <div class="container-fluid center-container">
  <div class="text-center content-vertical">
    <img src="../../assets/images/brand/astro.png" alt="Logo" class="logo mb-3 animate-logo" />
    <h1 class="welcome-text">
      Welcome to <span class="text-brand">BePositive</span>
    </h1>
  </div>
</div> -->


<div class="bg-light">
  <div class="container min-vh-100 d-flex flex-column justify-content-center align-items-center">
    <div class="text-center ">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="#dc3545" class="bi bi-exclamation-triangle"
        viewBox="0 0 16 16">
        <path
          d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
        <path
          d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
      </svg>
    </div>
    <div class="text-center"> <h1 class="fs-1 fw-bold text-danger">404</h1>
      <p class="fs-3"> <span class="text-danger">Oops!</span> Page not found.</p>
      <p class="lead">
        The page you're looking for doesn't exist or has been moved.
      </p>
    </div>
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
      <a href="https://admin.jyotishmentor.com/login" class="btn btn-primary btn-lg px-4 gap-3">Go to Jyotish Mentor Home</a>
      <a href="https://admin.jyotishmentor.com/login" class="btn btn-outline-secondary btn-lg px-4">Contact Support</a>
    </div>
  </div>
</div>